import { render, staticRenderFns } from "./ImagenesABM.vue?vue&type=template&id=4b2033ae&"
import script from "./ImagenesABM.vue?vue&type=script&lang=js&"
export * from "./ImagenesABM.vue?vue&type=script&lang=js&"
import style0 from "./ImagenesABM.vue?vue&type=style&index=0&id=4b2033ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports